// extracted by mini-css-extract-plugin
module.exports =  {"root":"vayv_szNdLUpv5ZC1Tku","suggestion":"_gBtKgBltQh4RP2OkKM_","loading":"Fy2TvfjiGjffIr0jMkR9","noResults":"yJpS8GffjEhs70Cb8BBP"};